module.exports = __webpack_public_path__ + "static/users-f07c2111565201ebbe52b57a2477af48.png";